import type { RichContentEditorProps } from './../../ricos-common';
import { IMAGE_TYPE } from './../../ricos-content';

const baseUrl = '/_serverless/ricos-media-services/media-token';

const getMediaToken = (() => {
  let mediaToken: string;

  return async (instance: string) => {
    if (!mediaToken) {
      const response = await fetch(baseUrl, { headers: { Authorization: instance } });
      mediaToken = await response?.text?.();
    }
    return mediaToken;
  };
})();

const getImageEditorSettings = async (
  instance: string,
  metaSiteId: string,
  initiator = 'ricos-default'
) => {
  const mediaToken = (await getMediaToken(instance))?.replace(/^"+|"+$/g, '');
  if (mediaToken && mediaToken.startsWith('JWS.')) {
    return {
      initiator,
      siteToken: mediaToken,
      metaSiteId,
      mediaRoot: 'photos',
    };
  }
  return null;
};

export default function imageEditorStrategy(
  instance: string,
  metaSiteId: string,
  userId: string,
  consumer?: string
): RichContentEditorProps {
  if (!(instance && userId && metaSiteId)) {
    return {
      config: {},
    };
  }

  const imageEditorWixSettings = getImageEditorSettings(instance, metaSiteId, consumer);
  return {
    config: {
      [IMAGE_TYPE]: {
        imageEditorWixSettings,
      },
    },
  };
}
